import React, { useMemo } from 'react';
import Navbar from '../components/layout/Navbar';
import { Link } from 'react-router-dom';
import { AdminTable } from '../components/layout/AdminTable';
import { AdminEmailTable } from '../components/layout/AdminEmailTable';
import { AdminMeetingTable } from '../components/layout/AdminMeetingTable';
import Tabs from '../components/layout/Tabs';
import { SelectColumnFilter } from '../utilities/tables';
import { makeUTCDateStr, makeLocalDateStr } from '../utilities/dates';

export default function AdminPage() {
  const columns = useMemo(
    () => [
      {
        Header: 'Name',
        accessor: 'name'
      },
      {
        Header: 'Title',
        accessor: 'title',
        disableSortBy: true
      },
      {
        Header: 'Affiliation',
        accessor: 'affiliation',
        disableSortBy: true
      },
      {
        Header: 'Elected',
        accessor: 'elected',
        Filter: SelectColumnFilter,
        disableSortBy: true,

        Cell: (props) => {
          return (
            <div>{props.value === true ? <span> &#10003;</span> : 'X'}</div>
          );
        }
      },
      {
        Header: 'Counties',
        accessor: 'counties',
        disableSortBy: true,
        Cell: (props) => {
          return (
            <div>
              {props.value?.map((county, idx) => (
                <p key={idx}>{county}</p>
              ))}
            </div>
          );
        }
      },
      {
        Header: 'HUCs',
        accessor: 'hucs',
        disableSortBy: true,
        Cell: (props) => {
          return (
            <div>
              {props.value?.map((county, idx) => (
                <p key={idx}>{county}</p>
              ))}
            </div>
          );
        }
      },
      {
        Header: 'Study Areas',
        accessor: 'study_areas',
        disableSortBy: true,
        Cell: (props) => {
          return <p>{props.value}</p>;
        }
      },
      {
        Header: 'Mitigation Areas',
        accessor: 'mitigation_areas',
        disableSortBy: true,
        Cell: (props) => {
          return <p>{props.value}</p>;
        }
      },
      {
        Header: 'Outreach Types',
        accessor: 'outreach_types',
        disableSortBy: true,
        Cell: (props) => {
          return <p>{props.value}</p>;
        }
      },
      {
        Header: 'Email Address',
        accessor: 'email',
        disableSortBy: true
      },
      {
        Header: 'Phone Number',
        accessor: 'phone',
        disableSortBy: true
      },
      {
        Header: 'Start Date',
        accessor: 'startdate',
        disableSortBy: true,
        Cell: ({ value }) => {
          return <p>{value ? makeUTCDateStr(value) : value}</p>;
        }
      },
      {
        Header: 'End Date',
        accessor: 'enddate',
        disableSortBy: true,
        Cell: ({ value }) => {
          return <p>{value ? makeUTCDateStr(value) : value}</p>;
        }
      },
      {
        Header: 'Term End Date',
        accessor: 'term_enddate',
        disableSortBy: true,
        Cell: ({ value }) => {
          return <p>{value ? makeUTCDateStr(value) : value}</p>;
        }
      },
      {
        Header: 'Notes',
        accessor: 'notes',
        disableSortBy: true
      }
    ],
    []
  );

  const meeting_columns = useMemo(
    () => [
      { Header: 'Meeting Name', accessor: 'meeting_name' },
      {
        Header: 'Type',
        accessor: 'meeting_type'
      },
      {
        Header: 'Location',
        accessor: 'meeting_location'
      },
      {
        Header: 'Date',
        accessor: 'date_time',
        Cell: ({ value }) => {
          return (
            <p>
              {value
                ? makeLocalDateStr(value, {
                    hour: 'numeric',
                    minute: 'numeric'
                  })
                : value}
            </p>
          );
        }
      },
      {
        Header: 'Document Files',
        accessor: 's3_prefix',
        disableFilters: true,
        filterable: false
      },
      {
        Header: 'Notes',
        accessor: 'notes',
        disableFilters: true,
        filterable: false
      }
    ],
    []
  );

  const email_columns = useMemo(
    () => [
      { Header: 'Email Subject', accessor: 'email_subject' },
      { Header: 'Date', accessor: 'date_time' },
      {
        Header: 'Document Files',
        accessor: 's3_prefix',
        disableFilters: true,
        filterable: false
      },
      {
        Header: 'Notes',
        accessor: 'notes',
        disableFilters: true,
        filterable: false
      }
    ],
    []
  );

  return (
    <div>
      <Navbar />
      <h2 style={{ color: 'red' }}>
        Administrative Page: Add or Update Contact Information
      </h2>
      <Tabs>
        <div label='Contacts' id='Contacts'>
          <Link to='/addContact'>
            <button className='btn' style={{ margin: '10px', width: '150px' }}>
              Add New Contact
            </button>
          </Link>
          <Link to='/addAffiliation'>
            <button className='btn' style={{ margin: '10px', width: '150px' }}>
              Add New Affiliation
            </button>
          </Link>
          <div className='wrapper'>
            <div style={{ flexGrow: '8', marginLeft: '10px', minWidth: 0 }}>
              <AdminTable columns={columns} />
            </div>
          </div>
        </div>
        <div label='Emails' id='Emails'>
          <Link to='/addEmail'>
            <button className='btn' style={{ margin: '10px', width: '150px' }}>
              Add New Email
            </button>
          </Link>
          <div className='wrapper'>
            <div style={{ flexGrow: '8', marginLeft: '10px', minWidth: 0 }}>
              <AdminEmailTable columns={email_columns} />
            </div>
          </div>
        </div>
        <div label='Meetings' id='Meetings'>
          <Link to='/addMeeting'>
            <button className='btn' style={{ margin: '10px', width: '150px' }}>
              Add New Meeting
            </button>
          </Link>
          <div className='wrapper'>
            <div style={{ flexGrow: '8', marginLeft: '10px', minWidth: 0 }}>
              <AdminMeetingTable columns={meeting_columns} />
            </div>
          </div>
        </div>
      </Tabs>
    </div>
  );
}


